import React, { useState } from 'react';
import Icon from '@material-ui/core/Icon';

export default function Instructions() {
  const [uploadState, setUploadState] = useState(false);
  const [downloadState, setDownloadState] = useState(false);
  const [downloadAsZipState, setDownloadAsZipState] = useState(false);
  const [hidden, setHidden] = useState(false);

  const toggleHide = () => setHidden(!hidden);

  return (
    <div className="flex instructions-container">
      <div className={`${hidden ? 'instructions-hide' : 'instructions'} bg-white`}>
        <div className="margin-bottom-30 flex flex-space-between" aria-hidden="true" onClick={() => setUploadState(!uploadState)}>
          <h3>
            How to Upload Files/Folders
          </h3>
          {uploadState ? (
            <Icon className="color-heading">keyboard_arrow_up</Icon>
          ) : (
            <Icon className="color-heading">keyboard_arrow_down</Icon>
          )}
        </div>
        {uploadState && (
          <>
            <p>1. Click on the name of the folder to navigate inside.</p>
            <p>2. Click on the (+) Add Button on the right and click on Upload.</p>
            <p>3. Select your files or folders to Upload.</p>
            <p>4. Click on the Upload button on the bottom right.</p>
            <p>You&apos;re done!</p>
          </>
        )}
        <div className="margin-top-30 flex flex-space-between" aria-hidden="true" onClick={() => setDownloadState(!downloadState)}>
          <h3>How to Download a Single File</h3>
          {downloadState ? (
            <Icon className="color-heading">keyboard_arrow_up</Icon>
          ) : (
            <Icon className="color-heading">keyboard_arrow_down</Icon>
          )}
        </div>
        {downloadState && (
          <>
            <p>1. Hover over a file with your cursor.</p>
            <p>2. Click on the ... icon on the right side of the file.</p>
            <p>3. Click Download.</p>
          </>
        )}
        <div className="margin-top-30 flex flex-space-between" aria-hidden="true" onClick={() => setDownloadAsZipState(!downloadAsZipState)}>
          <h3>How to Download Folders/Multiple Files</h3>
          {downloadAsZipState ? (
            <Icon className="color-heading">keyboard_arrow_up</Icon>
          ) : (
            <Icon className="color-heading">keyboard_arrow_down</Icon>
          )}
        </div>
        {downloadAsZipState && (
          <>
            <p>1. Click on the 'Download Folders/Multiple Files' button.</p>
            <p>2. Select the files/folders you want to download</p>
            <p>3. Click Download to download as a single zip file.</p>
          </>
        )}
      </div>
      <div className="bar flex items-center justify-center">
        {hidden ? (
          <Icon onClick={toggleHide} style={{ cursor: 'pointer' }}>chevron_right</Icon>
        ) : (
          <Icon onClick={toggleHide} style={{ cursor: 'pointer' }}>chevron_left</Icon>
        )}
      </div>
    </div>
  );
}
